import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import NoDataFound from "../NoDataFound/NoDataFound";
import CategoryItem from "./CategoryItem";
import { CloseIcon } from "../../Assets/Icons";
import {
  CREATE_CATEGORY,
  LIST_CATEGORY,
  UPDATE_CATEGORY,
  DELATE_CATEGORY,
  CATEGORY_TAGS_LIST,
  CREATE_TAG,
  UPDATE_TAG,
} from "../../apiClient/apiEndpoints";
import apiClient from "../../apiClient";
import { BtnLoading } from "../Loading/Loading";
import { SSO_URL } from "../../env";
import { tagDetails } from "../../Utils/apiCall";

let level = 1;

const Category = () => {
  const configData = useSelector((state) => state.configSlice);
  const [search, setSearch] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState({
    action: null,
    type: null,
    status: false,
    id: null,
    parentId: null,
  });
  const [tagModal, setTagModal] = useState({
    action: null,
    type: null,
    status: false,
    id: null,
    parentId: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    id: null,
    status: false,
  });
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [list, setList] = useState([]);
  const [taglist, setTagList] = useState([]);

  const handelOpenModal = (type, parentID) => {
    setOpenModal({
      action: "Add new",
      type: type,
      status: true,
      id: null,
      parentId: parentID,
    });
  };

  const handelTagOpenModal = (type, parentID) => {
    setTagModal({
      action: "Add Tag",
      type: type,
      status: true,
      id: null,
      parentId: parentID,
    });

    if (parentID) {
      getTagList(parentID);
    }
  };

  const handelOpenEditModal = (type, name, id, parentID) => {
    setOpenModal({
      action: "Edit",
      type: type,
      status: true,
      id: id,
      parentId: parentID,
    });

    setName(name);
  };

  const handelOpenDeleteModal = (id) => {
    setDeleteModal({
      id: id,
      status: true,
    });
  };

  const handelCloseDeleteModal = () => {
    setDeleteModal({
      id: null,
      status: false,
    });
  };

  const handelCloseModal = () => {
    setOpenModal({
      action: null,
      type: null,
      status: false,
      id: null,
      parentId: null,
    });

    setTagModal({
      action: null,
      type: null,
      status: false,
      id: null,
      parentId: null,
    });
    setDeleteModal({
      id: null,
      status: false,
    });
    setLoading(false);
    setError(null);
    setName("");
  };

  const getCategoryList = async () => {
    try {
      setFetchLoading(true);
      let data = await apiClient.get(`${SSO_URL}${LIST_CATEGORY}`);
      setList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setFetchLoading(false);
    }
  };
  const getTagList = async (categoryId) => {
    try {
      const data = await apiClient.get(`${SSO_URL}${CATEGORY_TAGS_LIST}/${categoryId}`);

      setTagList(data);
    } catch (err) {
      console.error("Error fetching tags", err);
    }
  };
  useEffect(() => {
    getCategoryList();
  }, []);

  const handleSaveEditTagCategory = async () => {
    if (loading) return;
    try {
      if (name.trim().length === 0) {
        setError("Kindly fill name.");
        setTimeout(() => setError(null), 3500);
        return;
      }
      setLoading(true);

      let bodyData = {
        name: name,
        parentId: openModal.parentId,
      };

      let type = openModal.id ? UPDATE_CATEGORY : CREATE_CATEGORY;
      if (openModal.id) {
        await apiClient.post(`${SSO_URL}${type}/${openModal.id}`, bodyData);
      } else {
        await apiClient.post(`${SSO_URL}${type}`, bodyData);
      }
      handelCloseModal();
      getCategoryList();
    } catch (error) {
      console.error(error);
      setError(error?.response?.data?.message || "Something went wrong.");
      setTimeout(() => setError(null), 3500);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTag = async () => {
    if (loading) return;
    try {
      if (name.trim().length === 0) {
        setError("Kindly fill name.");
        setTimeout(() => setError(null), 3500);
        return;
      }
      setLoading(true);

      let bodyData = {
        name: name,
        categoryId: tagModal.parentId,
      };

      let type = tagModal.id ? UPDATE_TAG : CREATE_TAG;
      if (tagModal.id) {
        await apiClient.post(`${SSO_URL}${type}/${tagModal.id}`, bodyData);
      } else {
        await apiClient.post(`${SSO_URL}${type}`, bodyData);
      }
      getTagList(tagModal.parentId);
      setName("");
    } catch (error) {
      console.error(error);
      setError(error?.response?.data?.message || "Something went wrong.");
      setTimeout(() => setError(null), 3500);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTagCategory = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await apiClient.get(`${SSO_URL}${DELATE_CATEGORY}/${deleteModal.id}`);
      handelCloseModal();
      getCategoryList();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="overview-page">
        <div className="row">
          <div className="col-md-6"> </div>
          <div className="col-md-6 d-flex justify-content-end align-item-center ">
            <button className="normalbtn" onClick={() => handelOpenModal("category")}>
              Add Category
            </button>
          </div>
        </div>

        {fetchLoading ? (
          <NoDataFound text="Data is fetching." />
        ) : list.length === 0 ? (
          <NoDataFound text="No data found." />
        ) : (
          list.length > 0 &&
          list.map((item, index) => {
            return (
              <CategoryItem
                level={level}
                key={item.id}
                category={item}
                tagModal={handelTagOpenModal}
                openModal={handelOpenModal}
                openEditModal={handelOpenEditModal}
                openDeleteModal={handelOpenDeleteModal}
              />
            );
          })
        )}
      </div>

      <Modal show={openModal.status} size="md" centered onHide={() => handelCloseModal()}>
        <Modal.Header className="modalheader justify-content-between">
          {openModal?.action && openModal.action} {openModal?.type && openModal.type.split(".").join(" ")}
          <span onClick={() => handelCloseModal()}>
            <CloseIcon />
          </span>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="row">
            <div className="col-12 standardinput">
              <label>
                {openModal?.type && openModal.type.split(".").join(" ")} Name
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="off"
                  name="moduleName"
                  id="moduleName"
                  className="input form-control"
                  type="text"
                />
                <p className="error"> {error} </p>
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="footerbtn pt-0">
          <Button onClick={() => handelCloseModal()}> Cancel </Button>
          <Button onClick={handleSaveEditTagCategory}>
            {" "}
            {loading ? <BtnLoading /> : openModal.id ? "Update" : "Add"}{" "}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal centered show={deleteModal.status} onHide={handelCloseDeleteModal}>
        <Modal.Header className="popupheader delete pt-4">Delete Category</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group pt-4 pb-5 m-0">
                <p className="popupheading delete p-0 m-0">Do you really want to delete this Category?</p>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-2 mb-2 footerbtn">
                  <button onClick={handelCloseDeleteModal}>Cancel</button>
                  <button onClick={handleDeleteTagCategory} className="ms-3">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={tagModal.status} size="md" centered onHide={() => handelCloseModal()}>
        <Modal.Header className="modalheader justify-content-between">
          {tagModal?.action && tagModal.action} {tagModal?.type && tagModal.type.split(".").join(" ")}
          <span onClick={() => handelCloseModal()}>
            <CloseIcon />
          </span>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="row">
            <div className="col-12 standardinput">
              <label>
                {tagModal?.type && tagModal.type.split(".").join(" ")} Name
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="off"
                  name="moduleName"
                  id="moduleName"
                  className="input form-control"
                  type="text"
                />
                <p className="errorStatus"> {error} </p>
              </label>

            </div>
            <h6 className="tag-heading">Tags List</h6>
            <div className="tag-list">
              <table className="tag-table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Tag Name</th>
                  </tr>
                </thead>
                <tbody>
                  {taglist.length > 0 ? (
                    taglist.map((tag, index) => (
                      <tr key={tag.id}>
                        <td>{index + 1}</td>
                        <td>{tag.name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">No tags found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="footerbtn pt-0">
          <Button onClick={() => handelCloseModal()}> Cancel </Button>
          <Button onClick={handleCreateTag}>
            {" "}
            {loading ? <BtnLoading /> : tagModal.id ? "Update" : "Add"}{" "}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Category;
